import createIcon from '../../createIcon';

/**
 * @component @name Doorbell
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0w0IDlWMjFIMjBWOUwxMiAzWk0xMiAxNy41QzExLjQ1IDE3LjUgMTEgMTcuMDUgMTEgMTYuNUgxM0MxMyAxNy4wNSAxMi41NSAxNy41IDEyIDE3LjVaTTE2IDE2SDhWMTVIOVYxMi42NkM5IDExLjEyIDkuODIgOS44NCAxMS4yNSA5LjVWOS4yNUMxMS4yNSA4Ljg0IDExLjU5IDguNSAxMiA4LjVDMTIuNDEgOC41IDEyLjc1IDguODQgMTIuNzUgOS4yNVY5LjVDMTQuMTkgOS44NCAxNSAxMS4xMiAxNSAxMi42NlYxNUgxNlYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Doorbell = createIcon('Doorbell', [
  [
    'path',
    {
      d: 'M12 3L4 9V21H20V9L12 3ZM12 17.5C11.45 17.5 11 17.05 11 16.5H13C13 17.05 12.55 17.5 12 17.5ZM16 16H8V15H9V12.66C9 11.12 9.82 9.84 11.25 9.5V9.25C11.25 8.84 11.59 8.5 12 8.5C12.41 8.5 12.75 8.84 12.75 9.25V9.5C14.19 9.84 15 11.12 15 12.66V15H16V16Z',
      key: '1ysb8u',
    },
  ],
]);

export default Doorbell;
